//* Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

//* Add the Web App's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDJFmd4P9PuNsEsHfrcXaylV_H8jmxhtVI",
  authDomain: "trigo-66dbb.firebaseapp.com",
  projectId: "trigo-66dbb",
  storageBucket: "trigo-66dbb.firebasestorage.app",
  messagingSenderId: "393238657027",
  appId: "1:393238657027:web:fab98e698cc2f2b637b636",
  measurementId: "G-LTPW1GZFWB",
};

//* Initialize Firebase
let firebase_app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

//* Initialize Firebase Auth and set persistence
const auth = getAuth(firebase_app);
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Session persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Failed to set session persistence:", error);
  });

export { auth };
export default firebase_app;
